<template>
  <div class="flex flex-col">
    <h2>Solicitudes</h2>

    <div class="flex flex-col lg:flex-row gap-4 lg:gap-6 mt-6 items-start">
      <status-side-nav :options="statusNavOptions" />

      <div class="flex-1 min-w-0 w-full">

    <div class="flex flex-col">
      <custom-search
        class="mt-6 w-full sm:w-[500px]"
        placeholder="Buscar por Cliente ó Mascota"
        v-model="searchText"
        @confirm="search"
        @clear="search"
      />

      <div class="card mt-6">
        <table class="table-auto text-sm mt-2 bg-white">
          <thead class="text-left">
            <tr class="bg-primary-100">
              <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">ID</th>
              <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Cliente</th>
              <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Mascotas</th>
              <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Tipo</th>
              <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Fecha de creación</th>
              <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="quoteRequest in quoteRequests" :key="quoteRequest.id" class="table-row">
              <td class="table-cell">
                {{ quoteRequest.id }}
              </td>
              <td class="table-cell">
                <div>
                  <router-link
                    :to="{
                      name: 'clientsDetail',
                      params: { id: quoteRequest.client.id },
                    }"
                    class="underline system-button"
                    >{{ quoteRequest.client.name }}
                    {{ quoteRequest.client.last_name }}</router-link
                  >
                </div>
              </td>
              <td class="table-cell">
                <div class="flex flex-wrap">
                  <div
                    v-for="pet in quoteRequest.pets"
                    :key="pet.id"
                    class="mr-4"
                  >
                    <router-link
                      :to="{
                        name: 'petsDetail',
                        params: { id: pet.id },
                      }"
                      class="underline system-button"
                      >{{ pet.name }}</router-link
                    >
                  </div>
                </div>
              </td>
              <td class="table-cell">
                <span
                  v-if="quoteRequest.source === 'reevaluation'"
                  class="badge badge-warning"
                >
                  <span class="badge-dot"></span> Reevaluación
                </span>
                <span v-else class="text-content-300 text-xs">Inicial</span>
              </td>
              <td class="table-cell">
                {{ formatDatetime(quoteRequest.created_at) }}
              </td>
              <td class="table-cell">
                <div class="flex space-x-1">
                  <router-link
                    :to="{
                      name: 'quoteRequestsDetail',
                      params: { id: quoteRequest.id },
                    }"
                    class="secondary-button"
                    >Detalle</router-link
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="loading" class="flex w-full h-full items-center">
          <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
        </div>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "@/components/ui/Pagination.vue";
import StatusSideNav from "@/components/ui/StatusSideNav";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Quote Requests",

  components: {
    Pagination,
    StatusSideNav,
  },

  data() {
    return {
      quoteRequests: null,
      loading: false,
      status: null,
      searchText: "",
      currentPage: 1,
      totalPages: 0,
    };
  },

  computed: {
    statusNavOptions() {
      return [
        { status: "pending", label: "Pendientes", icon: "🕐", activeClass: "text-tertiary-500" },
        { status: "completed", label: "Completadas", icon: "✅", activeClass: "text-success-500" },
        { status: "rejected", label: "Rechazadas", icon: "❌", activeClass: "text-error-500" },
      ].map((option) => ({
        label: option.label,
        icon: option.icon,
        to: { name: "quoteRequestsIndex", query: { status: option.status } },
        active: this.$route.query.status === option.status,
        activeClass: option.activeClass,
      }));
    },

    quotes() {
      if (!this.quoteRequests) {
        return [];
      }

      return this.quoteRequests.filter(
        (quoteRequest) => quoteRequest.quote !== null
      );
    },
  },

  created() {
    this.$store.commit("setSelectedTab", "quoteRequests");

    this.status = this.$route.query.status;
    if (!this.status) {
      this.$router.push({
        name: "quoteRequestsIndex",
        query: { status: "pending" },
      });
    }

    // this.loadQuoteRequests();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadQuoteRequests() {
      this.loading = true;

      try {
        const response = await api.quoteRequests.getAllWithQueryParams([
          { name: "status", value: this.status },
          {
            name: "page",
            value: this.currentPage,
          },
          {
            name: "search",
            value: this.searchText,
          },
        ]);
        this.quoteRequests = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    search() {
      this.currentPage = 1;
      this.loadQuoteRequests();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadQuoteRequests();
    },
  },

  watch: {
    "$route.query.status": {
      immediate: true,
      handler(newStatus) {
        this.status = newStatus || "pending";
        this.loadQuoteRequests();
      },
    },
  },
};
</script>